import { AnalyticsEventTopic } from '~/modules/analytics/analyticsHelper';
import { FeatureFlags } from '~/modules/feature_flags';
import { aiOverviewStore, selectAiOverviewListings } from '~/modules/stores/aiOverviewStore';
import { GA4AiSearchEvent, GtmEventType } from './gtmEventType';
import { INLINE_SUGGESTION_SEARCH_SOURCE } from '../searchSource';

// Kept verbatim (including the apostrophe and mixed case) because the GA4
// spec pins this exact string as the search_type dimension value.
export const INLINE_SUGGESTION_SEARCH_TYPE = "Didn't find a Match, Try these";
export { INLINE_SUGGESTION_SEARCH_SOURCE };

/**
 * Emits `custEv_search` after a user clicks a pill under the "Didn't find a
 * match? Try these" section on the search results page.
 *
 * The inline-suggestion pill click already navigates with
 * `?searchSource=inlineSuggestion` (results.ts), so by the time the next
 * results page fires `ANALYTICS_SEARCH_DONE` the `searchSource` is on the
 * event. This handler narrows on that source and reports the full payload —
 * the generic `GtmSearchType` still handles every other keyword search
 * unchanged.
 */
export class GtmInlineSuggestionSearchType extends GtmEventType {
    // @ts-expect-error * Automated Type Error Fix
    canHandle(event): boolean {
        return (
            event.topic === AnalyticsEventTopic.ANALYTICS_SEARCH_DONE &&
            event.searchContext?.type === 'keyword' &&
            event.searchContext?.searchSource === INLINE_SUGGESTION_SEARCH_SOURCE &&
            FeatureFlags.FF_ACE_ENABLE_AI_LISTINGS_SUMMARY_ANALYTICS_EVENTS
        );
    }

    // @ts-expect-error * Automated Type Error Fix
    getBody(event): GA4AiSearchEvent {
        const { queryText, totals } = event.searchContext;
        const apps = totals?.apps || 0;
        const consultants = totals?.consultants || 0;
        const agents = totals?.agents || 0;
        const slack = totals?.slack || 0;
        const externalAgents = totals?.externalAgents || 0;

        return {
            event: 'custEv_search',
            search_term: queryText,
            search_type: INLINE_SUGGESTION_SEARCH_TYPE,
            search_category: 'all',
            search_result_count: apps + consultants + agents + slack + externalAgents,
            app_results: apps,
            consultant_results: consultants,
            agent_results: agents,
            // Salesforce platform = Apps, matching platformFilter.ts. Agents are a
            // `tech=force/copilot` subset of apps, so they are not added again here.
            salesforce_results: apps,
            slack_results: slack,
            ai_summary_results: selectAiOverviewListings(aiOverviewStore.getState())?.length ?? 0,
        };
    }
}
